import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  FormHelperText,
  FormControl,
  CircularProgress,
  TextField
} from "@material-ui/core";

import { ExpandMore } from "@material-ui/icons";
import { Alert, Autocomplete } from "@material-ui/lab";
import {
  targetToOptions,
  reassignOptions,
  vehicleOptions,
  handoffType,
  changeDriverType,
  swapType
} from "@utils/constant";

import { useStore } from "@store/store";
import closeIcon from "@assets/images/close.svg";
import { materialCommonStyles } from "@utils/materialCommonStyles";
import { ReassignDriverStyle } from "./style";
import SelectJobPopup from "./select-job-popup";

function ReassignDriverHandoffPopup(props) {
  const classes = ReassignDriverStyle();
  const materialClasses = materialCommonStyles();
  const [scroll] = useState("body");
  const [state] = useStore();
  const [openSelectJobPopup, setOpenSelectJobPopup] = useState(false);
  const [selectedJobArray, setSelectedJobArray] = useState([]);
  const listDrivers = state?.driver?.getInterstateDriverData || [];

  const handleOpenSelectJobPopup = () => {
    setOpenSelectJobPopup(true);
    setSelectedJobArray(props.formik.values.listJobs);
  }
  const handleCloseSelectJobPopup = () => {
    setOpenSelectJobPopup(false);
    setSelectedJobArray([]);
  }

  const handleConfirmSelectJob = () => {
    if (selectedJobArray.length > 0) {
      if (selectedJobArray.length === state.job?.interstateJobsReassignData?.length) {
        props.formik.setFieldValue("handoffType", handoffType.all);
      }
      props.formik.setFieldValue("listJobs", selectedJobArray);
    } else {
      props.formik.setFieldValue("listJobs", []);
    }
    handleCloseSelectJobPopup();
  }

  const handleChange = (item) => {
    let jobId = item.id;
    const obj = {
      jobId,
      jobRunsheetsId: item?.jobRunsheets[0]?.id
    }
    const selectedIndex = selectedJobArray.findIndex((job) => job.jobId === jobId);

    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedJobArray, obj);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedJobArray.slice(1));
    } else if (selectedIndex === selectedJobArray.length - 1) {
      newSelected = newSelected.concat(selectedJobArray.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedJobArray.slice(0, selectedIndex),
        selectedJobArray.slice(selectedIndex + 1),
      );
    }
    setSelectedJobArray(newSelected);
  }

  const handleMainChangeCheckBox = (e) => {
    if (e.target.checked) {
      const newSelected = state.job?.interstateJobsReassignData?.map((job) => {
        return {
          jobId: job.id,
          jobRunsheetsId: job?.jobRunsheets[0]?.id
        };
      });
      setSelectedJobArray(newSelected);
    } else {
      setSelectedJobArray([]);
    }
  };

  return (
    <>
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
        scroll={scroll}
      >
        <div className="close-modal">
          <img src={closeIcon} alt="Close" onClick={props.handleClose} />
        </div>
        {props.error && <Alert severity="error">{props.error}</Alert>}
        <DialogTitle id="alert-dialog-title">
          Re-Assign Driver
        </DialogTitle>
        <form
          noValidate
          autoComplete="off"
          className={classes.customForm}
          onSubmit={props.formik.handleSubmit}
        >
          <DialogContent>
            <div className="form-row">
              <div className="form-group">
                <FormControl variant="outlined" className={classes.formControl}>
                  <label className="label-text">Re-assign Options</label>
                  <Select
                    id="handoffType"
                    displayEmpty
                    className={materialClasses.customSelect}
                    MenuProps={{
                      classes: { paper: materialClasses.customSelect },
                    }}
                    onChange={props.formik.handleChange("handoffType")}
                    value={props.formik.values.handoffType}
                    IconComponent={() => <ExpandMore />}
                  >
                    <MenuItem value={""} disabled>
                      Select Options
                    </MenuItem>
                    {
                      (
                        reassignOptions?.map((itm, indx) => {
                          return (
                            <MenuItem key={indx} value={itm.value}>
                              {itm.name}
                            </MenuItem>
                          );
                        })
                      )
                    }

                  </Select>
                  <FormHelperText className="error-text">
                    {props.formik.touched.handoffType &&
                      props.formik.errors.handoffType}
                  </FormHelperText>
                </FormControl>

                {props.formik.values.handoffType === handoffType.all && (
                  <FormControl variant="outlined" className={classes.formControl}>
                    <label className="label-text">Vehicle Options</label>
                    <Select
                      id="swapType"
                      displayEmpty
                      className={materialClasses.customSelect}
                      MenuProps={{
                        classes: { paper: materialClasses.customSelect },
                      }}
                      onChange={props.formik.handleChange("swapType")}
                      value={props.formik.values.swapType}
                      IconComponent={() => <ExpandMore />}
                    >
                      <MenuItem value={""} disabled>
                        Select Options
                      </MenuItem>
                      {(
                        vehicleOptions?.map((itm, indx) => {
                          if (
                            (itm.value === swapType.trailerOnly
                              && props.job?.trucks?.id
                              && props.job?.trailers?.id)
                            || itm.value !== swapType.trailerOnly
                          ) {
                            return (
                              <MenuItem key={indx} value={itm.value}>
                                {itm.name}
                              </MenuItem>
                            );
                          } else {
                            return null;
                          }
                        })
                      )}
                    </Select>
                    <FormHelperText className="error-text">
                      {props.formik.touched.swapType &&
                        props.formik.errors.swapType}
                    </FormHelperText>
                  </FormControl>
                )}

                <FormControl variant="outlined" className={classes.formControl}>
                  <label className="label-text">Target To</label>
                  <Select
                    id="targetTo"
                    displayEmpty
                    className={materialClasses.customSelect}
                    MenuProps={{
                      classes: { paper: materialClasses.customSelect },
                    }}
                    onChange={(e) => {
                      props.formik.handleChange("targetTo")(e);
                      props.formik.setFieldValue("assignDriver", "");
                    }}
                    value={props.formik.values.targetTo}
                    IconComponent={() => <ExpandMore />}
                  >
                    <MenuItem value={""} disabled>
                      Select Options
                    </MenuItem>
                    {(
                      targetToOptions?.map((itm, indx) => {
                        return (
                          <MenuItem key={indx} value={itm.value}>
                            {itm.name}
                          </MenuItem>
                        );
                      })
                    )}
                  </Select>
                  <FormHelperText className="error-text">
                    {props.formik.touched.targetTo &&
                      props.formik.errors.targetTo}
                  </FormHelperText>
                </FormControl>

                <FormControl variant="outlined" className={classes.formControl}>
                  <label className="label-text">Driver</label>
                  <Autocomplete
                    id="assignDriver"
                    popupIcon={<ExpandMore />}
                    className={materialClasses.inputAutoComplete}
                    options={listDrivers}
                    getOptionLabel={(option) => option.name}
                    value={
                      listDrivers?.find((opt) => opt.id === props.formik.values.assignDriver) || null
                    }
                    onChange={props.formik.handleChange("assignDriver")}
                    disableClearable
                    disabled={props.formik.values.targetTo !== changeDriverType.driver}
                    loading={state?.driver?.gettingInterstateDriver}
                    loadingText="Loading..."
                    noOptionsText="No options"
                    renderOption={(option) => (
                      <ul className={materialClasses.dropdownAutoComplete}>
                        <MenuItem
                          key={option.id}
                          value={option.id}

                        >
                          {option.name}
                        </MenuItem>
                      </ul>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        variant="outlined"
                        className="label-text"
                        placeholder={"Search interstate driver"}
                      />
                    )}
                  />
                  <FormHelperText className="error-text">
                    {props.formik.touched.assignDriver &&
                      props.formik.errors.assignDriver}
                  </FormHelperText>
                </FormControl>

                {props.formik.values.handoffType === handoffType.individual
                  && (<FormControl variant="outlined" className={classes.formControl}>
                    <label className="label-text"></label>
                    <Button
                      id="listJobs"
                      className="primary-btn linkButton"
                      color="inherit"
                      disableElevation
                      underlinenone="true"
                      onClick={handleOpenSelectJobPopup}
                    >
                      SELECT JOBS
                    </Button>
                    <FormHelperText className="error-text">
                      {props.formik.touched.listJobs &&
                        props.formik.errors.listJobs}
                    </FormHelperText>
                  </FormControl>)}
              </div>
            </div>

          </DialogContent>
          <DialogActions className="bottom-button-block">
            <Button
              className="primary-btn gray-border-btn"
              color="inherit"
              disableElevation
              onClick={props.handleClose}
            >
              CANCEL
            </Button>
            <Button
              className="orange-btn primary-btn center-loading-indicator"
              color="inherit"
              disableElevation
              type="submit"
              disabled={state.job?.creatingHandoff}
            >
              {
                state.job?.creatingHandoff ? (
                  <CircularProgress color="inherit" />
                ) : (
                  "Re-Assign"
                )
              }
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <SelectJobPopup
        handleClose={handleCloseSelectJobPopup}
        open={openSelectJobPopup}
        formik={props.formik}
        selectedJobArray={selectedJobArray}
        handleChange={handleChange}
        handleMainChange={handleMainChangeCheckBox}
        handleConfirmSelectJob={handleConfirmSelectJob}
        handleSorting={props.handleSorting}
        order={props.order}
        orderBy={props.orderBy}
      />
    </>
  );
}

export default ReassignDriverHandoffPopup;
